import { render, staticRenderFns } from "./RenderController.vue?vue&type=template&id=04038856&"
import script from "./RenderController.vue?vue&type=script&lang=js&"
export * from "./RenderController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports